import { makeAPICall, makeAPICallAsync } from '../helpers/Util';
let _ = require('lodash');
export const DEFAULT_SERVING_DESC = "1 serving";
export const DEFAULT_SERVING_NUMBER = 1;
export const HIT_TYPE = {
  // This is the text that shows up in the dropdown
  UserHistory: `This User's History`,
  AllNoTags: `All Users' Histories that are missing tags` // Used by datatool only
};

export const SOURCE_NAME = {
  FS_Food: 'FS_Food',
  FS_Recipe: 'FS_Recipe'
}
var lastInitiatedQuery = '';

export async function getFood(foodId) {
  try {
    const response = await makeAPICallAsync(`/food/v2/${foodId}`, null, 'GET');
    if (response.error) {
      console.log(response.error);
      return { error: response.error };
    } else {
      console.log(response);
      return response;
    }
  } catch (error) {
    console.log(error);
    return { error: error };
  }
}

export async function getFoodByNameAndServing(userId, name, servingUnit) {
  try {
    const response = await makeAPICallAsync(`/food/v2/findByNameAndServing`, {
      userId,
      name,
      servingUnit
    });

    if (response.error) {
      console.log(response.error);
      return { error: response.error };
    } else {
      console.log(response);
      return response;
    }
  } catch (error) {
    console.log(error);
    return { error: error };
  }
}

export function searchFood(query, userId, maxCount, callback) {
  lastInitiatedQuery = query ? query : '';
  console.log("calling /food/v2/search");
  makeAPICall('/food/v2/search', {
    query,
    userId,
    maxCount
  }, (response) => {
    if (lastInitiatedQuery === query) { // Ignore outdated queries
      lastInitiatedQuery = '';
      callback(response.hits, response.total);
    }
  }, (error) => {
    callback([], 0);
  });
}

export function deleteFood(foodId) {
  makeAPICall('/food/v2/delete', {
    foodId
  });
}

export function deleteServing(foodId, allServings, servingName) { // Ignore the version number. If we delete it, we delete it.
  let newServings = _.cloneDeep(allServings);
  let index = _.findIndex(newServings, item => item.name === servingName); // Just remove the first occurrence, not all the matches. This is because we delete servings to dedupe merged foods.
  newServings.splice(index, 1);

  makeAPICall('/food/v2/deleteServing', {
    foodId, allServings, servingName
  });
  return newServings;
}


// WEBPACK FOOTER //
// ./src/helpers/esUserFoodHistory.js